// @flow

import * as React from 'react';
import {
  VenueInfoContainer,
  VenueTitle,
  VenueDetailsRight,
  VenueDetailsLeft
} from 'common/components/venueCard/VenueInfo';
import VenueLink from 'common/components/venueCard/VenueLink';
import { UnpublishedVenueWarning, RestrictedVenueWarning } from './Warnings';
import ReviewCount from './ReviewCount';
import type { VenueResult, HighlightCapacityType } from 'search/types';

import styles from './FeaturedVenueInfo.scss';

export type Props = {|
  venue: VenueResult,
  onClickVenueLink?: () => void,
  openInNewTab: boolean,
  highlightCapacity: HighlightCapacityType,
  isActive: boolean
|};

export default function VenueInfo(props: Props): React.Node {
  const {
    venue,
    onClickVenueLink,
    openInNewTab,
    highlightCapacity,
    isActive
  } = props;

  return (
    <VenueLink
      venue={venue}
      openInNewTab={openInNewTab}
      onClickVenueLink={onClickVenueLink}
    >
      <VenueInfoContainer className={styles.searchInfoContainer}>
        <VenueTitle
          venue={venue}
          isActive={isActive}
          warnings={<Warnings venue={venue} />}
        />
        <VenueDetailsLeft
          venue={venue}
          additionalItem={<ReviewCount venue={venue} />}
        />
        <VenueDetailsRight
          venue={venue}
          highlightCapacity={highlightCapacity}
        />
      </VenueInfoContainer>
    </VenueLink>
  );
}

function Warnings({ venue }: { venue: VenueResult, ... }) {
  return (
    <>
      {!venue.published && <UnpublishedVenueWarning />}
      {venue.restricted && <RestrictedVenueWarning />}
    </>
  );
}
